export default __webpack_public_path__ + "static/media/DSC_9131-thumb.3fb4de42.jpg";